
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TradingHours"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TradingHourDay"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"openingTime"},"name":{"kind":"Name","value":"opening_time"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"closingTime"},"name":{"kind":"Name","value":"closing_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hourStatus"},"name":{"kind":"Name","value":"hour_status"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hourType"},"name":{"kind":"Name","value":"hour_type"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":178}};
    doc.loc.source = {"body":"fragment TradingHours on TradingHourDay {\n  date\n  openingTime: opening_time\n  closingTime: closing_time\n  closed\n  description\n  hourStatus: hour_status\n  hourType: hour_type\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
